import React, { useState } from "react";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import SearchIcon from "@material-ui/icons/Search";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

import AppPage from "components/AppPage";
import AppPageHeader from "components/AppPageHeader";
import AppPageContent from "components/AppPageContent";
import { useDebouncedNameValue } from "hooks/useSearch";

import PendingRoleRequests from "./PendingRoleRequests";
import Users from "./Users";
import useStyles from "./styles";

const tabs = {
  users: {
    name: "users",
    title: "Users"
  },
  pendingRoleRequests: {
    name: "pendingRoleRequests",
    title: "Requests"
  }
};

const AdminPage = () => {
  const classes = useStyles();
  const [searchQuery, setSearchQuery] = useState<string>("");
  const debouncedSearchQuery = useDebouncedNameValue(searchQuery, {
    timeout: 332 //Corresponds to 20 frames at 60 Hz. Equals to MaterialUI debounce timeout x2.
  });

  const [selectedTab, setSelectedTab] = useState<string>(tabs.users.name);

  const handleTabChange = (
    event: React.ChangeEvent<{ value: string }>,
    value: string
  ) => {
    setSelectedTab(value);
  };

  const handleSearchQueryChange = event => {
    setSearchQuery(event.target.value);
  };

  return (
    <AppPage className={classes.root}>
      <AppPageHeader className={classes.header}>
        <Tabs
          className={classes.tabs}
          value={selectedTab}
          onChange={handleTabChange}
        >
          <Tab
            classes={{
              root: classes.tab,
              selected: classes.tabSelected
            }}
            label={tabs.users.title}
            value={tabs.users.name}
          />
          <Tab
            classes={{
              root: classes.tab,
              selected: classes.tabSelected
            }}
            label={tabs.pendingRoleRequests.title}
            value={tabs.pendingRoleRequests.name}
          />
        </Tabs>
        <div className={classes.searchWrapper}>
          <OutlinedInput
            placeholder={"Search"}
            classes={{
              root: classes.search,
              input: classes.searchInput,
              focused: classes.searchInputFocused,
              notchedOutline: classes.searchInputNotchedOutline
            }}
            startAdornment={
              <InputAdornment variant={"outlined"} position={"start"}>
                <SearchIcon className={classes.searchIcon} />
              </InputAdornment>
            }
            type={"search"}
            value={searchQuery}
            onChange={handleSearchQueryChange}
          />
        </div>
      </AppPageHeader>

      <AppPageContent className={classes.appPageContent}>
        {selectedTab === "users" && <Users query={debouncedSearchQuery} />}
        {selectedTab === "pendingRoleRequests" && (
          <PendingRoleRequests query={debouncedSearchQuery} />
        )}
      </AppPageContent>
    </AppPage>
  );
};

export default AdminPage;
